export default __webpack_public_path__ + "static/media/tools.f383b8c0.svg";